import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiX } = FiIcons;

const InstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);

      // Check if the app is not already installed
      const isAppInstalled = window.matchMedia('(display-mode: standalone)').matches;
      if (!isAppInstalled) {
        // Show our install prompt after a short delay
        setTimeout(() => {
          setShowPrompt(true);
        }, 3000);
      }
    });

    // Check if already installed as PWA
    window.addEventListener('appinstalled', () => {
      // Hide the prompt when the app is installed
      setShowPrompt(false);
      setDeferredPrompt(null);
      // Log analytics event
      console.log('BPA Success Center was installed');
    });
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    // We no longer need the prompt
    setDeferredPrompt(null);

    // Hide our UI regardless of outcome
    setShowPrompt(false);

    // Log outcome
    console.log(`User ${outcome === 'accepted' ? 'accepted' : 'dismissed'} the install prompt`);
  };

  if (!showPrompt) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-lg shadow-lg border border-gray-200 p-4 z-50"
    >
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Install BPA Success Center</h3>
          <p className="text-gray-600 text-sm mb-4">
            Install this app on your device for quick access to your coaching dashboard and member profiles even when offline.
          </p>
          <div className="flex space-x-3">
            <button
              onClick={handleInstallClick}
              className="flex items-center space-x-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              <SafeIcon icon={FiDownload} className="w-4 h-4" />
              <span>Install</span>
            </button>
            <button
              onClick={() => setShowPrompt(false)}
              className="px-4 py-2 text-gray-700 hover:text-gray-900 font-medium transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
        <button
          onClick={() => setShowPrompt(false)}
          className="text-gray-400 hover:text-gray-600 p-1"
          aria-label="Close"
        >
          <SafeIcon icon={FiX} className="w-5 h-5" />
        </button>
      </div>
    </motion.div>
  );
};

export default InstallPrompt;